"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SimpleStagedObject = _interopRequireDefault(require("redux-less/SimpleStagedObject"));

var _constants = require("settings-ui-sdk/CanSpamSettings/constants");

var properties = [_constants.COMPANY_CITY, _constants.COMPANY_COUNTRY, _constants.COMPANY_NAME, _constants.COMPANY_PHONE, _constants.COMPANY_STATE, _constants.COMPANY_STREET_ADDRESS_1, _constants.COMPANY_STREET_ADDRESS_2, _constants.COMPANY_ZIP, _constants.IS_DEFAULT, _constants.NAME];
var CreateFooter = new _SimpleStagedObject.default({
  stagedSelector: function stagedSelector(state) {
    return state.modules.marketing.email.staging.createFooter;
  },
  namespace: 'email',
  objectType: 'CreateFooter',
  properties: properties
});
var _default = CreateFooter;
exports.default = _default;
module.exports = exports.default;